export const SET_TODOS = 'todos/setTodos'
export const ADD_TODO = 'todo/addTodo'
export const UPDATE_TODO = 'todo/updateTodo'
export const DELETE_TODO = 'todo/deleteTodo'
export const SET_ACTIVE_TODOS = 'todos/setActiveTodos'
export const SET_FINISHED_TODOS = 'todos/setFinishedTodos'
export const DELETE_ACTIVE_TODO = 'todo/deleteActiveTodo'
export const DELETE_FINISHED_TODO = 'todo/deleteFinishedTodo'

export function setTodos (payload) {
  return { type: SET_TODOS, payload }
}

export function addTodo (payload) {
  return { type: ADD_TODO, payload }
}

export function updateTodo (payload) {
  return { type: UPDATE_TODO, payload }
}

export function deleteTodo (payload) {
  return { type: DELETE_TODO, payload }
}

export function setActiveTodos (payload) {
  return { type: SET_ACTIVE_TODOS, payload }
}

export function setFinishedTodos (payload) {
  return { type: SET_FINISHED_TODOS, payload }
}

export function deleteActiveTodo (payload) {
  return { type: DELETE_ACTIVE_TODO, payload }
}

export function deleteFinishedTodo (payload) {
  return { type: DELETE_FINISHED_TODO, payload }
}
